import { UserActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import { USER_ENDPOINTS_URLS, USER_TAGS } from "./api-users.constant";
import { Profile, User, Users } from "./api-users.type";

export const {
  useReadProfileQuery,
  useReadManyUserQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useApproveUserMutation,
  useLazyReadManyUserQuery,
  useReadOneUserQuery,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    readProfile: builder.query<Profile, void>({
      query: () => ({
        url: USER_ENDPOINTS_URLS.readProfile,
        method: "get",
      }),
      providesTags: [USER_TAGS.user_profile],
    }),

    readManyUser: builder.query<Users, QueryArgsNew<UserActions["readMany"]>>({
      query: ({ query }) => ({
        url: USER_ENDPOINTS_URLS.readMany(query),
        method: "get",
      }),
      providesTags: [USER_TAGS.users],
    }),

    readOneUser: builder.query<User, QueryArgsNew<UserActions["readOne"]>>({
      query: ({ params }) => ({
        url: USER_ENDPOINTS_URLS.readOne(params),
        method: "get",
      }),
      providesTags: [USER_TAGS.user],
    }),

    createUser: builder.mutation<unknown, QueryArgsNew<UserActions["create"]>>({
      query: ({ payload }) => ({
        url: USER_ENDPOINTS_URLS.create,
        method: "post",
        payload,
      }),
      invalidatesTags: [USER_TAGS.users],
    }),

    updateUser: builder.mutation<unknown, QueryArgsNew<UserActions["update"]>>({
      query: ({ params, payload }) => ({
        url: USER_ENDPOINTS_URLS.update(params),
        method: "put",
        payload,
      }),
      invalidatesTags: [USER_TAGS.users, USER_TAGS.user],
    }),

    deleteUser: builder.mutation<unknown, QueryArgsNew<UserActions["delete"]>>({
      query: ({ params }) => ({
        url: USER_ENDPOINTS_URLS.delete(params),
        method: "delete",
      }),
      invalidatesTags: [USER_TAGS.users],
    }),

    approveUser: builder.mutation<unknown, QueryArgsNew<UserActions["approve"]>>({
      query: ({ params }) => ({
        url: USER_ENDPOINTS_URLS.approve(params),
        method: "post",
      }),
      invalidatesTags: [USER_TAGS.users, USER_TAGS.user],
    }),
  }),
});
